// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getInvoiceFileUrl,
  uploadInvoicefile
} from "../../../admin/actions/billingAdminActions";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import HistoryBillings from "../../components/billings/HistoryBillings";

type HistoryBillingReduxPropsType = {
  histories: Array<{ [key: string]: * }>,
  companyId?: string,
  isAdmin?: boolean,
  setActionError?: Function,
  openSnackbar?: Function,
  actions: { getInvoiceFileUrl: Function, uploadInvoicefile: Function }
};

class HistoryBillingRedux extends Component<HistoryBillingReduxPropsType, *> {
  downloadFile = (billingId: string, billingUid: string): * => {
    this.props.actions.getInvoiceFileUrl(
      billingId,
      billingUid,
      (url: string): * => window.open(url),
      this.props.setActionError ? this.props.setActionError : undefined
    );
  };

  uploadFile = (billingId: string, billingUid: string, paidOn: Date, file: File, doneCall: Function): * => {
    this.props.actions.uploadInvoicefile(
      this.props.companyId,
      billingId,
      billingUid,
      paidOn,
      file,
      doneCall,
      this.props.setActionError ? this.props.setActionError : undefined
    );
  };

  render(): React$Element<*> {
    return (
      <HistoryBillings
        histories={this.props.histories}
        isAdmin={this.props.isAdmin}
        companyId={this.props.companyId}
        downloadFile={this.downloadFile}
        uploadFile={this.uploadFile}
        openSnackbar={this.props.openSnackbar}
      />
    );
  }
}


const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { getInvoiceFileUrl, uploadInvoicefile },
    dispatch
  )
});

export default connect(
  null,
  mapDispatchToProps
)(HistoryBillingRedux);
